import React from 'react';
import {
  IconDeviceDinModuleWithAntenna,
  IconDeviceFlushMountedBlindController,
  IconDeviceFlushMountedController,
  IconDeviceFlushMountedGateController,
  IconDeviceFlushMountedRelay,
  IconDeviceFlushMountedRGBLightController,
  IconDeviceMultisensor,
  IconDeviceSocketPlugIn,
} from '../../../../assets/device-icons';
import { IconConnectionError } from '../../../../assets/icons/icon-connection-error';
import { IconRecovery } from '../../../../assets/icons/icon-recovery';
import DeviceIconCommon from '../../../../components/device-icon';
import { DeviceModel } from '../../types/devices';
import './index.scss';

type DeviceIconProps = {
  model: string;
  disconnected?: boolean;
  recovery?: boolean;
  statusIcon?: React.ReactNode;
};

const deviceIconByModel: Record<string, React.ReactNode> = {
  [DeviceModel.LavvaDouble]: <IconDeviceFlushMountedController />,
  [DeviceModel.LavvaGate]: <IconDeviceFlushMountedGateController />,
  [DeviceModel.LavvaLed]: <IconDeviceFlushMountedRGBLightController />,
  [DeviceModel.LavvaPower]: <IconDeviceDinModuleWithAntenna />,
  [DeviceModel.LavvaSwitch16A]: <IconDeviceFlushMountedRelay />,
  [DeviceModel.LavvaPlug]: <IconDeviceSocketPlugIn />,
  [DeviceModel.LavvaTherm]: <IconDeviceDinModuleWithAntenna />,
  [DeviceModel.LavvaBlind]: <IconDeviceFlushMountedBlindController />,
  [DeviceModel.LavvaSwitch]: <IconDeviceFlushMountedRelay />,
  [DeviceModel.SmartAWSC]: <IconDeviceFlushMountedGateController />,
  [DeviceModel.SmartAWMulti]: <IconDeviceFlushMountedGateController />,
  [DeviceModel.SmartAWGate]: <IconDeviceFlushMountedGateController />,
  [DeviceModel.SmartAWLed]: <IconDeviceFlushMountedRGBLightController />,
  [DeviceModel.LavvaEkoOzePv]: <IconDeviceFlushMountedController />,
  [DeviceModel.Atrom]: <IconDeviceFlushMountedController />,
  [DeviceModel.LavvaSensHub]: <IconDeviceMultisensor />,
  [DeviceModel.LavvaWallDuo]: <IconDeviceFlushMountedBlindController />,
  [DeviceModel.SmartAWRoll]: <IconDeviceFlushMountedGateController />,
  [DeviceModel.LavvaUnity]: <IconDeviceDinModuleWithAntenna />,
  [DeviceModel.TauronPlug]: <IconDeviceSocketPlugIn />,
};

const DeviceIcon: React.FC<DeviceIconProps> = ({ model, disconnected, recovery, statusIcon }) => {
  const getStatusIcon = () => {
    if (statusIcon) return <div className="status-icon">{statusIcon}</div>;
    return disconnected ? (
      <IconConnectionError big details size={12} />
    ) : recovery ? (
      <IconRecovery big details />
    ) : null;
  };

  const icon = deviceIconByModel[model] || <IconDeviceFlushMountedController />;
  const status = getStatusIcon();

  return <DeviceIconCommon icon={icon} statusIcon={status} />;
};

export default DeviceIcon;
